import React from 'react'

import { useTranslation } from 'react-i18n-lite'

import { AlertModal, useIsMobile } from '@yes.technology/react-toolkit'

import { useFilterFieldsContext } from '../../context'
import {
  useSectionFilteraction,
  useSectionNavigation
} from '../Section/SectionContext'

import GroupControlsView from './GroupControlsView'
import { useGroupRemoveModal } from './useGroupRemoveModal'
import LeftHeaderElement from './LeftHeaderElement'
import CenterHeaderElement from './CenterHeaderElement'
import RightHeaderElement from './RightHeaderElement'
import { useCollapsibleCardSync } from './useCollapsibleCardSync'
import type {
  GroupControlsAreaLineProps,
  GroupControlsProps
} from './GroupControls.types'

const GroupControls = ({ children }: GroupControlsProps) => {
  const { t } = useTranslation()
  const { isOpen, open, close, onModalSuccess } = useGroupRemoveModal()
  const isMobile = useIsMobile()

  const { groupPosition } = useSectionNavigation()
  const { shouldHideFilters } = useSectionFilteraction()
  const { config, styling } = useFilterFieldsContext()

  const { displayOptionsForElement: displayOptionsElement } = config
  const { navigationSliderBackgroundColor, navigationSliderColor } = styling

  const collapsibleCardRef = useCollapsibleCardSync(shouldHideFilters)

  const areaLineProps: GroupControlsAreaLineProps = {
    ...(!navigationSliderBackgroundColor && { colorScheme: 'gray' as const }),
    style: {
      ...(navigationSliderBackgroundColor && {
        backgroundColor: navigationSliderBackgroundColor
      })
    },
    className: isMobile ? 'p-2' : ''
  }

  return (
    <>
      <GroupControlsView
        leftHeaderElement={<LeftHeaderElement />}
        centerHeaderElement={<CenterHeaderElement onRemoveClick={open} />}
        rightHeaderElement={<RightHeaderElement onRemoveClick={open} />}
        hideFieldsCollapsibleContainer={
          displayOptionsElement?.hideFieldsCollapsibleContainer
        }
        collapsibleCardRef={collapsibleCardRef}
        areaLineProps={areaLineProps}
        iconColor={navigationSliderColor || '#303032'}
        defaultOpenState={!shouldHideFilters}
      >
        {children}
      </GroupControlsView>
      <AlertModal
        isOpen={isOpen}
        onCancel={close}
        onSuccess={onModalSuccess}
        mainMessage={t('filter-fields.modal.main-message')}
        helpMessage={t('filter-fields.modal.help-message', {
          groupNumber: groupPosition.toString()
        })}
        cancelButtonMessage={t('filter-fields.modal.cancel')}
        returnButtonMessage={t('filter-fields.modal.return')}
      />
    </>
  )
}

export default GroupControls
